import { FC } from 'react';
import { IonIcon, IonItem, IonList, IonPopover, IonText } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { IActionMenuProps } from './ActionMenu';

const useStyles = createUseStyles({
    popover: {
        '&::part(content)': {
            width: 'auto',
            minWidth: 200,
            maxWidth: 650
        }
    }
});

// NOTE: trigger is the id of the button/element that launched the menu. Ionic uses this for
// positioning which we want, but it also uses it to open/close the popover automatically,
// which we don't want because we're using isOpen instead. We workaround this conflict by
// setting trigger on IonPopover only when isOpen is true.
export const PopoverMenu: FC<IActionMenuProps> = ({ actions, isOpen, onClose, trigger, side = 'bottom', alignment = 'end' }) => {
    const classes = useStyles();

    const hasIcons = actions.some(a => a.icon);

    const onSelect = (handler?: () => void) => {
        if (onClose) {
            onClose();
        }
        if (handler) {
            // need timeout to allow popover to close
            // before handler can navigate to another page
            setTimeout(handler);
        }
    };

    return (
        <IonPopover arrow={false} side={side} alignment={alignment} trigger={isOpen ? trigger : undefined} className={classes.popover} isOpen={isOpen} onDidDismiss={onClose}>
            <IonList lines="full" style={{paddingTop: 0, paddingBottom: 0}}>
                {actions.filter(a => !a.disabled).map(({ text, icon, role, handler }, idx) => (
                    <IonItem
                        button
                        detail={false}
                        key={`${text}-${idx}`}
                        onClick={() => onSelect(handler)}
                    >
                        {hasIcons &&
                            <IonIcon slot="start" icon={icon} color={role === 'destructive' ? 'danger' : 'medium'} />
                        }
                        <IonText style={{paddingRight: 30}} color={role === 'destructive' ? 'danger' : undefined}>{text}</IonText>
                    </IonItem>
                ))}
            </IonList>
        </IonPopover>
    );
};
